<template>
  <section>
    <PageTitle>
      <span v-html="$store.state.app.pageName" />
    </PageTitle>
    <PageContent :top-sticked="true" :loading="loading">
      <Container :mobile-fluid="true">
        <NoticeBox type="info">
        </NoticeBox>
        <NoticeBox type="error" v-if="!this.isAllSend">
          未送信の施行後アンケートがあります。回答完了後「送信」押下をお願い致します。
        </NoticeBox>
        <ul class="list-group">
          <li
            class="list-group-item"
            v-for="after_survey in afterSurveys"
            :key="after_survey.id"
            :class="{ 'is-active': after_survey.isDone }"
          >
            <div class="list-group-text">
              <p :class="{ 'text-light': after_survey.isDone }">
                {{ $domUtils.decode(after_survey.title) }}
              </p>
            </div>
            <div class="list-group-control">
              <div class="icon-links">
                <IconLink
                  :icon-class="['fas', 'fa-edit']"
                  :disabled="after_survey.isDone"
                  :paused="after_survey.isInProgress"
                  :checked="after_survey.isDone"
                  :to="$wcRouter.path({ name: 'after-survey.show', params: { afterSurveyId: after_survey.id } })"
                >回答</IconLink>
                <IconLink
                  :icon-class="['far', 'fa-list-alt']"
                  :disabled="after_survey.isNotStarted"
                  :checked="after_survey.isDone"
                  :to="$wcRouter.path({ name: 'after-survey.answer', params: { afterSurveyId: after_survey.id } })"
                >結果</IconLink>
                <IconButton
                  :icon-class="['far', 'fa-paper-plane']"
                  :disabled="!after_survey.isNotSend"
                  :checked="after_survey.isAnswerComplete"
                  @click="send(after_survey.id)"
                >送信</IconButton>
              </div>
            </div>
          </li>
        </ul>
      </Container>
    </PageContent>
  </section>
</template>

<script>
import IconLink from '@/components/IconLink.js'
import IconButton from '@/components/IconButton.js'
import NoticeBox from '@/components/NoticeBox.vue'
import api from '@/api/after-survey'
import AfterSurvey from '@/utils/AfterSurvey'
import { renderError } from '@/utils/error'

export default {
  components: {
    IconLink,
    IconButton,
    NoticeBox,
  },

  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'after-survey' }
    }
  },

  data() {
    return {
      isAllSend: false,
      loading: false,
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    afterSurveys() {
      return this.$store.state.afterSurvey.items
    },
  },

  methods: {
    async fetchAfterSurveys() {
      try {
        const response = await api.afterSurveys(this.businessId)

        let afterSurveyClass = response.map(res => new AfterSurvey({
          id: res.after_survey_id,
          title: res.after_survey_title,
          questionCount: res.question_count,
          answerCount: res.answer_count,
          answerComplete: res.answer_complete,
          revision: res.revision
        }))
        const isNotSendCount = afterSurveyClass.filter(item => item.answerCount > 0 && !item.answerComplete).length
        this.isAllSend = (isNotSendCount === 0) ? true : false;

        this.$store.commit('afterSurvey/SET_ITEMS', afterSurveyClass)
      } catch(err) {
        renderError(err)
      } finally {
        this.loading = false
      }
    },

    async send(afterSurvenId) {
      this.loading = true

      try {
        await api.send(this.businessId, afterSurvenId)
      } catch(err) {
        renderError(err)
      }
      this.$withLoading(this.fetchAfterSurveys)
    },

  },

  created() {
    this.$withLoading(this.fetchAfterSurveys)
  }
}
</script>
